/**
 * supported data types for metric values
 */
export enum MetricDataTypeEnum {
  String = "string",
  SmartText = "smartText",
  Number = "number",
  Timestamp = "timestamp",
  Time = "time",
  Date = "date",
  Yesno = "yesno",
  Json = "json",
  Userselect = "userselect",
  Image = "image",
}
